export default __webpack_public_path__ + "static/media/Cherry 9781843628187.b5a1e4b9.jpg";